import {Grid, CircularProgress, Button} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {observer} from 'mobx-react';
import React from 'react';
import {DayYearCard, DayStatsCard, DayLiferCard, DayCityCard, DayMonthCard, DayDateCard} from '../DayReport.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_DAY} from './StatsCommon.js';
import {getMidnightEpoch} from '../Util.js';
import {COMM_OK} from '../WsR2.js';

const StatsDay = observer((props) => {
	const gStorage = useGlobalStorage();

	function dayRepRxWs(status, msg, priv) {
		if (status !== COMM_OK) {
			console.error('mainRxWs: error ', status);
			return -1;
		}

		// console.log('msg', msg.data.dayreport);

		msg.data.dayreport.epoch = priv;
		gStorage.stats.setObsList(msg.data.dayreport);
	}

	function dayStatsLoad() {
		const midnight = getMidnightEpoch(gStorage.stats.dailyDate.toJSDate());
		const ts = new Date();
		ts.setTime(midnight * 1000);
		const month = ts.getMonth();

		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'day',
			op: 'report',
			data: {
				user: gStorage.conn.user.id,
				country: 0,
				epoch: midnight,
				month: month
			}
		}

		gStorage.conn.ws.send(msg, dayRepRxWs, midnight);
	}

	/* ------------------------------------------------------------------ */

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_DAY)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		dayStatsLoad();

		return (
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} />
			</Grid>
		);
	}

	return (
		<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
			<Grid style={{width: 300, marginBottom: 10}} align={'center'}>
				<div>
				<Button 
					variant="contained" 
					style={{marginRight: 4, height: 40}}
					disabled={!gStorage.stats.obsList}
					onClick={() => {
						gStorage.stats.setDailyDate(gStorage.stats.dailyDate.minus({'days': 1}));
						gStorage.stats.setObsList(null);
					}}
				>
					&lt;
				</Button>

				<DatePicker
					onChange={(val) => {gStorage.stats.setDailyDate(val); gStorage.stats.setObsList(null);}}
					value={gStorage.stats.dailyDate}
					disableFuture={true}
					yearsOrder='desc'
					slotProps={{
						textField: {
							size: 'small',
							sx: {
								backgroundColor: 'white',
								width: 160
							}
						}
					}}
				/>

				<Button 
					variant="contained" 
					style={{marginLeft: 4, height: 40}}
					disabled={getMidnightEpoch(gStorage.stats.dailyDate.toJSDate()) >= getMidnightEpoch(new Date()) || !gStorage.stats.obsList}
					onClick={() => {
						gStorage.stats.setDailyDate(gStorage.stats.dailyDate.plus({'days': 1}));
						gStorage.stats.setObsList(null);
					}}
				>
					&gt;
				</Button>
				</div>
			</Grid>

			<Grid style={{width: 300}} align={'center'}>
				<DayStatsCard stats={gStorage.stats.obsList} />
				<DayLiferCard stats={gStorage.stats.obsList} />
				<DayYearCard stats={gStorage.stats.obsList} />
				<DayMonthCard stats={gStorage.stats.obsList} />
				<DayCityCard stats={gStorage.stats.obsList} />
				<DayDateCard stats={gStorage.stats.obsList} />
			</Grid>
		</Grid>
	);
});

export default StatsDay;
